// translations/pages/teaching/nl.js
export const teachingPageNL = {
  hero: {
    title: 'Trainingen in edge-AI & de EU AI Act',
    subtitle: 'AI-advies voor ondernemingen • Edge-ontwikkeling • Rechtszekere implementatie'
  },
  intro: 'Gespecialiseerde AI-trainingen voor directie, projectleiders en ontwikkelteams. Van strategisch advies tot technische implementatie - in overeenstemming met de EU AI Act.',

  // Nieuwe EU AI Act Sectie
  eu_ai_act: {
    title: 'EU AI Act-compliance & edge computing',
    subtitle: 'Rechtszekere AI-implementatie met lokale gegevensverwerking',
    description: 'De EU AI Act stelt strikte regels voor het gebruik van kunstmatige intelligentie in Europa. Edge computing biedt de ideale oplossing: gevoelige gegevens blijven lokaal, compliance wordt eenvoudiger en de controle over AI-systemen blijft in uw handen.',
    benefits: [
      'Gegevensbescherming door lokale verwerking',
      'Minder complexe compliance',
      'Volledige controle over AI-beslissingen',
      'Transparantie en traceerbaarheid',
      'Minimale juridische risico\'s',
      'Onafhankelijkheid van cloudaanbieders'
    ],
    highlight: 'Edge computing + EU AI Act = rechtszekere AI zonder compromissen'
  },

  offerings: {
    title: 'Trainingsaanbod',
    categories: [
      {
        title: 'Kunstmatige intelligentie & machine learning',
        icon: 'brain',
        topics: [
          'Generatieve AI & large language models (edge & cloud)',
          'Klassieke machine learning (geoptimaliseerd voor edge)',
          'Deep learning & neurale netwerken (edge-deployment)',
          'Computer vision & NLP (oplossingen geschikt voor edge)',
          'RAG-systemen & fine-tuning van LLM\'s (edge & cloud)',
          'Autonome AI-agenten (edge computing)',
          'EU AI Act-compliance & rechtszekerheid'
        ]
      },
      {
        title: 'Data science & statistiek',
        icon: 'chart',
        topics: [
          'Beschrijvende & inferentiële statistiek',
          'Datamodellering & data-analyse',
          'Tijdreeksanalyse',
          'Econometrie voor bedrijfskunde en economie',
          'Biostatistiek voor de natuurwetenschappen',
          'A/B-testen & experimenteel ontwerp'
        ]
      },
      {
        title: 'Softwarearchitectuur & beveiliging',
        icon: 'shield',
        topics: [
          'Modulaire architecturen',
          'Losse koppeling & clean code',
          'Ontwerp van microservices',
          'IT-beveiliging & compliance',
          'DevOps & CI/CD',
          'Cloudarchitecturen'
        ]
      }
    ]
  },

  target_groups: {
    title: 'Doelgroepen',
    groups: [
      {
        title: 'Directie & beslissers',
        description: 'Strategisch AI-advies, kostenanalyse en investeringsbeslissingen',
        formats: ['Directiebriefings', 'ROI-analyses', 'Strategisch advies'],
        focus: 'Businesscases, EU AI Act-compliance, budgetplanning'
      },
      {
        title: 'Projectleiders & managers',
        description: 'AI-projectmanagement, technologiekeuze en implementatiestrategieën',
        formats: ['Managementworkshops', 'Technologie-assessments', 'Roadmapontwikkeling'],
        focus: 'Projectplanning, leveranciersselectie, risicomanagement'
      },
      {
        title: 'IT-ontwikkelaars & engineers',
        description: 'Praktijkgerichte ontwikkeling van edge-AI, technische implementatie en deployment',
        formats: ['Technische deep dives', 'Codereviews', 'Architectuurworkshops'],
        focus: 'Edge computing, fine-tuning van LLM\'s, systeemintegratie'
      },
      {
        title: 'Vakspecialisten',
        description: 'Inzicht in AI, prompttechnieken en praktische toepassing in het dagelijkse werk',
        formats: ['Gebruikerstrainingen', 'Promptworkshops', 'Ontwikkeling van use cases'],
        focus: 'Praktische toepassing, integratie in workflows, hogere productiviteit'
      },
      {
        title: 'Studenten & academici',
        description: 'Universitair onderwijs, bijles en begeleiding van wetenschappelijke projecten',
        formats: ['Colleges', 'Bijles', 'Scriptiebegeleiding'],
        focus: 'Statistiek, econometrie, onderzoeksmethoden'
      }
    ]
  },

  expertise: {
    title: 'Technische expertise',
    items: [
      'Ontwikkeling van strategische AI-roadmaps voor ondernemingen',
      'Edge-AI-systemen met RAG/GRAG-architecturen en fine-tuning met LoRA/QLoRA',
      'Compliancestrategieën voor de EU AI Act en rechtszekere implementatie',
      'ROI-analyse en investeringsplanning voor AI-projecten',
      'Autonome AI-agenten met toolsets en redeneervermogen',
      'Verandermanagement voor de invoering van AI in organisaties',
      'Cloud- en on-premises-strategieën (Azure, STACKIT)',
      'Prompt engineering en optimalisatie van workflows'
    ]
  },

  technologies: {
    title: 'Technologiestack',
    list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata'
  },

  clients: {
    title: 'Sectoren & instellingen',
    sectors: [
      'Zorgverzekeraars',
      'Uitgeverijen',
      'Banken & fintech',
      'Industrie & IoT',
      'Onderzoek & universiteiten',
      'Adviesbureaus',
      'Start-ups'
    ]
  },

  workshops: {
    title: 'Werkvormen',
    formats: [
      {
        title: 'Directiebriefing',
        duration: '2-4 uur',
        description: 'Strategisch overzicht voor de directie met de nadruk op ROI en de EU AI Act'
      },
      {
        title: 'Managementworkshop',
        duration: '1-2 dagen',
        description: 'Training voor projectleiders over AI-implementatie en verandermanagement'
      },
      {
        title: 'Technische deep dive',
        duration: '2-5 dagen',
        description: 'Praktijkgerichte ontwikkeling van edge-AI voor IT-teams en engineers'
      },
      {
        title: 'Gebruikerstraining',
        duration: '0,5-1 dag',
        description: 'Praktische toepassing van AI voor vakspecialisten'
      },
      {
        title: 'Individuele coaching',
        duration: 'Naar behoefte',
        description: 'Persoonlijke begeleiding en projectondersteuning'
      }
    ]
  },
  sidebar: {
    languagesLabel: 'Talen:',
    languagesValue: 'DE / EN / NL',
    focusLabel: 'Focus:',
    specializationTitle: 'Specialisatie',
    specializationItems: [
      'Edge-AI voor lokale gegevensverwerking zonder afhankelijkheid van de cloud',
      'Implementatie conform de EU AI Act voor rechtszekerheid'
    ],
    benefitsTitle: 'Voordelen',
    benefits: [
      'Afgestemd op de doelgroep',
      'Direct toepasbaar',
      'Gericht op ROI',
      'Op afstand of op locatie'
    ]
  },
  cta: {
    title: 'Klaar voor een strategische AI-transformatie?',
    description: 'Van advies aan de directie tot technische implementatie - laten we uw specifieke eisen bespreken.',
    button: 'Adviesgesprek aanvragen',
    email: 'info@paioneer.eu',
    subject: 'Aanvraag training'
  }
};
